import React, { useEffect, useRef, useState } from 'react'
import { RiDeleteBin2Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { LuUsers } from "react-icons/lu";
import { HiOutlineDocumentText } from "react-icons/hi";
import { getPartnersData, addPartnersData, deletePartnerData, editPartnersData } from "../../controllers/trainingPartners.controller"
import toast from 'react-hot-toast';
import Page from "../../Components/Page";

const TrainingPartners = () => {
    const navigate = useNavigate();
    const [image, setImage] = useState(null);
    const [previewValues, setPreviewValues] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
  
    const [modalData, setModalData] = useState({ index: null, value: "" });
    const [selectedFile, setSelectedFile] = useState(null);
    const [data, setData] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState(null);

    const [addImage, setAddImage] = useState(null);
    const [addSelectedFile, setAddSelectedFile] = useState(null);

    const add_partner_nameRef = useRef();
    const add_urlRef = useRef();

    const edit_partner_nameRef = useRef();
    const edit_urlRef = useRef();

    

   
    // const handleImageChange = (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         setImage(URL.createObjectURL(file));
    //         setSelectedFile(file)
    //     } else setSelectedFile(null)

    // };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        handleFileSelected(file);
    };


    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        handleFileSelected(file);
    };


    const handleFileSelected = (file) => {
        if (file) {
            if (file.size > 1024 * 1024) {  // 1MB limit
                toast.error("File size exceeds 1MB.");
                return;
            }
            const imageUrl = URL.createObjectURL(file);
            if (selectedRowId) {
                setImage(imageUrl); // Set for Edit
                setSelectedFile(file);
            } else {
                setAddImage(imageUrl); // Set for Add
                setAddSelectedFile(file);
            }
        } else {
            setImage(null); // Clear Edit
            setAddImage(null); // Clear Add
            setSelectedFile(null);
            setAddSelectedFile(null);
        }
    };

    const removeImage = () => {
        setImage(null); // Reset the image state
        setAddImage(null); // Also reset the addImage state
        setSelectedFile(null);
        setAddSelectedFile(null);
    };

    const handlePreviewChange = (index, field, value) => {
        const updatedValues = [...previewValues];
        updatedValues[index][field] = value;
        setPreviewValues(updatedValues);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

    };




    const handleModalSave = () => {
        handlePreviewChange(modalData.index, "value", modalData.value);
        setIsModalOpen(false);
    };

    const fetchTableData = async () => {
        const res = await getPartnersData()

        console.log('res => ', res)

        if (res.status === 200) {
            const apiData = res?.data?.data;
            const tableData = apiData?.map((d) => ({
                id: d.id,
                image: d.image_url,
                partner_name: d.partner_name,
                url: d.url
            }))
            setData(tableData)
        }
    }

    useEffect(() => {
        fetchTableData()
    }, [])

    const addPartnerDetails = async () => {


        try {
            const partner_name = add_partner_nameRef.current.value;
            const url = add_urlRef.current.value;
            toast.loading("plaese wait");
            const res = await addPartnersData({ file: addSelectedFile, partner_name, url })
            const message = res.data.message;
            toast.dismiss();
            if (res.status === 200) {
                toast.success(message);
                setImage(null);
                setAddImage(null);
                setSelectedRowId(null);
                add_partner_nameRef.current.value = ''
                add_urlRef.current.value = ''
                fetchTableData()

            }
            else {
                toast.error(message);
            }

        } catch (error) {
            console.log(error);
            const message = error?.response?.data?.message || "something went wrong";
            toast.dismiss();
            toast.error(message);
        }
    }

    const editPartnerDetails = async () => {
        try {
            if (selectedRowId) {
                const partner_name = edit_partner_nameRef.current.value;
                const url = edit_urlRef.current.value;
                toast.loading("plaese wait");
                const res = await editPartnersData({ id: selectedRowId, file: selectedFile, partner_name, url })
                const message = res.data.message;
                toast.dismiss();
                if (res.status === 200) {
                    toast.success(message);
                    setImage(null);
                    setAddImage(null);
                    setSelectedRowId(null);
                    add_partner_nameRef.current.value = ''
                    edit_urlRef.current.value = ''
                    fetchTableData()
                    document.getElementById("modal-editPartnDetails").close()
                }
                else {
                    toast.error(message);
                }
            }
        } catch (error) {
            console.log(error);
            const message = error?.response?.data?.message || "something went wrong";
            toast.dismiss();
            toast.error(message);
        }
    }

    const handleRemoveImage = () => {
        setImage(null); // Reset the image state
    };


    const deleteTableRow = async () => {
        try {
            if (selectedRowId) {
                toast.loading("Please wait...");
                const res = await deletePartnerData({ id: selectedRowId })
                const message = res.data.message;
                toast.dismiss();
                if (res.status === 200) {
                    toast.success(message);
                    setSelectedRowId(null);
                    fetchTableData()
                    document.getElementById("modal-delete").close()
                } else {
                    toast.error(message);
                }
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.error || "Something went wrong!";
            toast.dismiss();
            toast.error(message);
        }
    }
    console.log('selected file => ',)
    return (
        <div>

            <Page className="px-8 py-6">

                <div className="p-6">

                    <div className='flex items-center gap-10 text-xl'>
                        <div className="text-[#4B465C] ">
                        Career / <hi className="text-[black] bg-white mt-6"> Training Partners</hi>
                        </div>
                    </div>
                     <div className="flex items-center mt-4 mb-4 space-x-4">
                              <button
                                className="flex items-center px-4 py-2 text-white bg-[#92288C] rounded-lg shadow hover:bg-[#6C0B67]"
                                onClick={() => navigate("/sab/training-partners")}
                              >
                                <LuUsers className="mr-2" />
                                Training Partners
                              </button>
                               <button
                                  className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
                                  onClick={() => navigate("/sab/training-partner-docs")}
                                >
                                  <HiOutlineDocumentText className="mr-2" />
                                  Training Partner Documents
                                </button>
                            
                            </div>

                    <div className="container">
                        <div className="p-6 mx-auto bg-white rounded-lg shadow-md">
                            {/* <h1 className="mb-4 text-xl font-bold text-gray-700">
                    Home page / Partners-Accreditations Management
                </h1> */}

                            <form onSubmit={handleSubmit}>
                                <h1 className="mb-4 text-xl font-bold text-gray-700">Add Partner Details</h1>

                                <div className="grid grid-cols-2 gap-6">

                                    <div className="mb-6">
                                        <h1 className="block text-black font-medium mb-2 text-[18px]" htmlFor="welcomeMessage">
                                            Logo <b className="text-[#4B465C]">(Accept: .jpg, .png)</b>
                                        </h1>
                                        <div className="flex flex-col items-center justify-center mt-2 border-2 border-gray-300 border-dashed rounded-lg h-36" onDragOver={handleDragOver} onDrop={handleDrop}>
                                            {/* {image ? (
                                                
                                                <>
                                                <img src={image}
                                                    alt="Uploaded Preview"
                                                    className="object-contain w-auto h-28" />
                                                <button
                                                    onClick={handleRemoveImage}
                                                    
                                                >
                                                    Remove Image
                                                </button>
                                            </>
                                            ) : (
                                                <div className="text-gray-500">
                                                    <div className="flex justify-center">
                                                        <svg
                                                            xmlns="testing imgage"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth={1.5}
                                                            stroke="currentColor"
                                                            className="w-10 h-10"
                                                        >
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                                        </svg>
                                                    </div>
                                                    <p>Drag and drop image here</p>
                                                    <p className="text-sm text-center text-gray-400">
                        Any size of image, will automatically adjust to the frame 
                        </p>
                                                    <div className='flex gap-10'>
                                                        <label className="px-4 py-2 text-[#92288C] rounded-md cursor-pointer border-2 border-[#92288C] hover:bg-[#92288C] hover:text-white">
                                                            <input
                                                                type="file"
                                                                accept=".jpg, .png"
                                                                onChange={handleImageChange}
                                                                className="hidden"
                                                            />
                                                            Browse image
                                                        </label>
                                                    </div>
                                                </div>
                                            )} */}
                                            {addImage ? (
                                                <div className="relative">
                                                    <img
                                                        src={addImage}
                                                        alt="Uploaded Preview"
                                                        className="object-contain w-auto h-28"
                                                    />
                                                    <button
                                                        onClick={removeImage}
                                                        className="absolute top-0 right-0 p-1 text-red-500 bg-white rounded-full hover:text-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="text-gray-500">
                                                    <div className="flex justify-center">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth={1.5}
                                                            stroke="currentColor"
                                                            className="w-10 h-10"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                d="M12 4.5v15m7.5-7.5h-15"
                                                            />
                                                        </svg>
                                                    </div>
                                                    <p>Drag and drop image here</p>
                                                    <p className="text-sm text-center text-gray-400">
                                                        Maximum file size is 1MB
                                                    </p>
                                                </div>
                                            )}
                                            <label className="text-[#92288C] cursor-pointer">
                                                <input
                                                    type="file"
                                                    accept=".jpg, .png,.webp"
                                                    onChange={handleImageChange}
                                                    className="hidden"
                                                />
                                                Browse image
                                            </label>
                                        </div>
                                    </div>

                                    <div>
                                        <h1 className="block text-black font-medium mb-2 text-[18px]" htmlFor="welcomeMessage">
                                            About
                                        </h1>

                                        <div className="w-full mb-4 text-left">
                                            <div>
                                                <label className="block mb-1 font-medium text-gray-600">Partner Name</label>
                                                <input
                                                    // type="text"
                                                    // onChange={(e) => handlePreviewChange(e.target.value)}
                                                    ref={add_partner_nameRef}
                                                    type="text"
                                                    id="partner_name"
                                                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:[#92288C]"
                                                />
                                            </div>
                                            <div className="">
                                                <label className="block mb-1 font-medium text-gray-600">URL</label>
                                                <input
                                                    ref={add_urlRef}
                                                    type="text"
                                                    id="url"
                                                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:[#92288C]"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button
                                    className="px-4 py-2 bg-[#92288C] text-white rounded-md hover:bg-[#7a2175] justify-end"
                                    onClick={() => addPartnerDetails()}
                                >
                                    Add
                                </button>
                            </form>
                        </div>

                        <div className="p-6 mx-auto mt-10 bg-white rounded-lg shadow-md">


                            <table className="w-full bg-white border-collapse rounded-lg shadow-md">
                                <thead>
                                    <tr className="bg-gray-100 text-[#4B465C]">
                                        <th className="w-1/4 px-4 py-2 text-center">Preview</th>
                                        <th className="w-1/4 px-4 py-2 text-center">Partner Name</th>

                                        <th className="w-1/4 px-4 py-2 text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={item.id} className="border-b hover:bg-gray-50">

                                            <td className="px-4 py-2 text-center">
                                                <div className="w-16 h-16 mx-auto overflow-hidden bg-gray-200 rounded-md">
                                                    <img
                                                        src={item.image} // including a image
                                                        alt={`Preview ${index + 1}`}
                                                        className="object-cover w-full h-full"
                                                    />
                                                </div>
                                            </td>


                                            <td className="px-4 py-2 text-center">{item.partner_name}</td>


                                            <td className="px-4 py-2 text-center">
                                                <div className="flex justify-center gap-4">
                                                    <button
                                                        onClick={() => {
                                                            setSelectedRowId(item.id)
                                                            document.getElementById("modal-delete").showModal();
                                                        }}
                                                        className="flex items-center px-3 py-1 bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300"
                                                    >
                                                        Delete
                                                        <RiDeleteBin2Line className="ml-2" />
                                                    </button>

                                                    {/* <button
                                                        onClick={() => {
                                                            setSelectedRowId(item.id)
                                                            setImage(item.image)
                                                            edit_partner_nameRef.current.value = item.partner_name
                                                            edit_urlRef.current.value = item.url
                                                            document.getElementById("modal-editPartnDetails").showModal();
                                                        }}
                                                        className="px-3 py-1 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md flex items-center gap-1">
                                                        Edit
                                                        <FiEdit />
                                                    </button> */}
                                                    <button
                                                        onClick={() => {
                                                            setSelectedRowId(item.id);
                                                            setImage(item.image);
                                                            setAddImage(null); // Clear Add section image
                                                            setAddSelectedFile(null); // Clear Add section selected file
                                                            edit_partner_nameRef.current.value = item.partner_name;
                                                            edit_urlRef.current.value = item.url;
                                                            document.getElementById("modal-editPartnDetails").showModal();
                                                        }}
                                                        className="px-3 py-1 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md flex items-center gap-1"
                                                    >
                                                        Edit
                                                        <FiEdit />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>


                            
                        </div>


                        <dialog
                            id="modal-delete"
                            className="inset-0 z-50 rounded-lg modal modal-bottom sm:modal-middle"
                        >

                            <div className="relative z-10 w-full max-w-lg p-6 mx-auto bg-white rounded-lg shadow-lg">
                                <div className="text-center">
                                    <h2 className="text-xl font-bold text-gray-900">
                                        Delete
                                    </h2>
                                    <p className="font-bold text-gray-500">
                                        Are you sure?
                                    </p>
                                </div>


                                <div className="flex justify-center mt-4 space-x-4">
                                    <button
                                        onClick={() => {
                                            setSelectedRowId(null)
                                            document.getElementById("modal-delete").close()
                                        }}
                                        className="px-6 py-3 text-gray-600 transition bg-gray-200 rounded-lg hover:bg-gray-200 active:scale-95 hover:shadow-lg"
                                    >
                                        No
                                    </button>
                                    <button
                                        onClick={async () => {
                                            deleteTableRow();
                                        }}
                                        className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </dialog>


                        <dialog
                            id="modal-editPartnDetails"
                            className="modal modal-bottom xl:modal-middle inset-0 z-50 rounded-lg w-[500px]"
                        >
                            <div className="w-full max-w-lg p-6 mx-auto">
                                <h1 className="mb-4 text-xl font-bold text-gray-700">Edit Partner Details</h1>

                                <div className="grid grid-cols-2 gap-6">

                                    <div className="mb-6">
                                        <h1 className="block text-black font-medium mb-2 text-[18px]" htmlFor="welcomeMessage">
                                            Logo <b className="text-[#4B465C]">(Accept: .jpg, .png)</b>
                                        </h1>
                                        <div className="flex flex-col items-center justify-center mt-2 border-2 border-gray-300 border-dashed rounded-lg h-36" onDragOver={handleDragOver} onDrop={handleDrop}>
                                            {/* {image ? (
                                                <>
                                                    <img src={image}
                                                        alt="Uploaded Preview"
                                                        className="object-contain w-auto h-28" />
                                                    <button
                                                        onClick={handleRemoveImage}
                                                        
                                                    >
                                                        Remove Image
                                                    </button>
                                                </>

                                            ) : (
                                                <div className="text-gray-500">
                                                    <div className="flex justify-center">
                                                        <svg
                                                            xmlns="testing imgage"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth={1.5}
                                                            stroke="currentColor"
                                                            className="w-10 h-10"
                                                        >
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                                        </svg>
                                                    </div>
                                                    <p>Drag and drop image here</p>
                                                    <p className="text-sm text-center text-gray-400">
                        Any size of image, will automatically adjust to the frame 
                        </p>
                                                    <div className='flex gap-10'>
                                                        <label className="px-4 py-2 text-[#92288C] rounded-md cursor-pointer border-2 border-[#92288C] hover:bg-[#92288C] hover:text-white">
                                                            <input
                                                                type="file"
                                                                accept=".jpg, .png"
                                                                onChange={handleImageChange}
                                                                className="hidden"
                                                            />
                                                            Browse image
                                                        </label>
                                                        <button
                                                            onClick={handleRemoveImage}
                                                            className="px-4 py-2 bg-white text-[#EA5455] rounded-md border-2 border-[#EA5455] hover:bg-[#EA5455] hover:text-white"
                                                        >
                                                            Remove Image
                                                        </button>
                                                    </div>
                                                </div>
                                            )} */}
                                            {image ? (
                                                <div className="relative">
                                                    <img
                                                        src={image}
                                                        alt="Uploaded Preview"
                                                        className="object-contain w-auto h-28"
                                                    />
                                                    {/* <button
                                                        onClick={removeImage}
                                                        className="absolute top-0 right-0 p-1 text-red-500 bg-white rounded-full hover:text-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                                        </svg>
                                                    </button> */}
                                                </div>
                                            ) : (
                                                <div className="text-gray-500">
                                                    <div className="flex justify-center">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth={1.5}
                                                            stroke="currentColor"
                                                            className="w-10 h-10"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                d="M12 4.5v15m7.5-7.5h-15"
                                                            />
                                                        </svg>
                                                    </div>
                                                    <p>Drag and drop image here</p>
                                                    <p className="text-sm text-center text-gray-400">
                                                        Maximum file size is 1MB
                                                    </p>
                                                </div>
                                            )}
                                            {/* {image && <button onClick={() => setImage(null)}>Remove Image</button>} */}
                                            <label className="text-[#92288C] cursor-pointer">
                                                <input
                                                    type="file"
                                                    accept=".jpg, .png,.webp"
                                                    onChange={handleImageChange}
                                                    className="hidden"
                                                />
                                                Browse image
                                            </label>
                                        </div>
                                    </div>

                                    <div>
                                        <h1 className="block text-black font-medium mb-2 text-[18px]" htmlFor="welcomeMessage">
                                            About
                                        </h1>

                                        <div className="w-full mb-4 text-left">
                                            <div>
                                                <label className="block mb-1 font-medium text-gray-600">Partner Name</label>
                                                <input
                                                    // type="text"
                                                    // onChange={(e) => handlePreviewChange(e.target.value)}
                                                    ref={edit_partner_nameRef}
                                                    type="text"
                                                    id="partner_name"
                                                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:[#92288C]"
                                                />
                                            </div>
                                            <div className="">
                                                <label className="block mb-1 font-medium text-gray-600">URL</label>
                                                <input
                                                    ref={edit_urlRef}
                                                    type="text"
                                                    id="url"
                                                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:[#92288C]"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <button
                                className="px-4 py-2 bg-[#92288C] text-white rounded-md hover:bg-[#7a2175] justify-end"
                                onClick={() => editPartnerDetails()}
                            >
                                Edit
                            </button> */}


                                <div className="flex justify-between">
                                    <button
                                        className="px-4 py-2 text-gray-500 border border-gray-300 rounded-md"
                                        onClick={() => {
                                            setSelectedRowId(null)
                                            setImage(null)


                                            edit_partner_nameRef.current.value = ''


                                            edit_urlRef.current.value = ''

                                            document.getElementById("modal-editPartnDetails").close()
                                        }}
                                    >
                                        Back
                                    </button>
                                    <button
                                        className="px-4 py-2 bg-[#92288C] text-white rounded-md hover:bg-[#7a2175] justify-end"
                                        onClick={() => editPartnerDetails()}
                                    >
                                        Edit Slide
                                    </button>
                                </div>
                            </div>

                        </dialog>


                    </div>
                </div>
            </Page>
        </div>

    )
}

export default TrainingPartners

